// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import { connect, Dispatch } from 'react-redux'; // eslint-disable-line no-unused-vars
import formatPhone from 'lib/formatPhone';
import MapPin from 'shared/components/MapPin';
import Icon from 'shared/components/Icon';
import { showModal } from 'shared/actions/UnboundModalActions';
import classes from './LocationInfoCard.module.scss';
import { Location } from '../types'; // eslint-disable-line no-unused-vars

/** @typedef {{
  dispatch: Dispatch<any>
  location: Location,
  distance: number,
  acceptingNewPatients: boolean
}} LocationInfoCardPropsType */

/** @type { React.ValidationMap<LocationInfoCardPropsType> } */
const propTypes = {
  location: PropTypes.object.isRequired,
  distance: PropTypes.number.isRequired,
  acceptingNewPatients: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

/** @type { StatelessComponent<LocationInfoCardPropsType> } */
const LocationInfoCard = ({ location, distance, acceptingNewPatients, dispatch }) => {
  const { address } = location;

  return (
    <div className={classes.LocationInfoCard}>
      {acceptingNewPatients || (
        <div className={classes.not_accepting}>Not Accepting New Patients</div>
      )}
      <div className={classes.header}>
        <div className={classes.map_pin_container}>
          <MapPin />
        </div>
        <div className={classes.heading}>
          <span
            className="fake-link"
            onClick={() => dispatch(showModal({ name: 'location', locationId: location.id }))}
          >
            {location.name}
          </span>
        </div>
      </div>
      <div className={classes.midsection}>
        <div className={classes.distance_stat}>
          <Icon name="compass" /> {Math.round(distance * 100) / 100} mi
        </div>
        <p>{address.streetAddress}</p>
        {address.streetAddressLine2 && <p>{address.streetAddressLine2}</p>}
        <p>
          {address.city}, {address.state} {address.zip}
        </p>
      </div>
      <div className={classes.footer}>
        <div className={classes.footer__left}>
          <Icon name="phone" />{' '}
          {location.phone ? (
            formatPhone(location.phone)
          ) : (
            <span className={classes.unavailable}>unavailable</span>
          )}
        </div>
        <div className={classes.footer__vert} />
        <div className={classes.footer__right}>
          <Icon name="fax" />{' '}
          {location.fax ? (
            formatPhone(location.fax)
          ) : (
            <span className={classes.unavailable}>unavailable</span>
          )}
        </div>
      </div>
    </div>
  );
};

LocationInfoCard.displayName = 'LocationInfoCard';
LocationInfoCard.propTypes = propTypes;

export default connect()(LocationInfoCard);
